function e(o) {
  return typeof o == "boolean";
}
export {
  e as isBoolean
};
